<template>
  <div class="global-tool-bar" :class="barWrapperClass">
    <Tooltip :content="buttonTip" placement="top" theme="light" transfer :delay="tipDelayTime">
      <Icon v-if="!customer" :color="iconColor" :class="customerClass" @click.native="onToolBarClick" :type="iconType" :size="iconSize"  />
      <i v-if="customer" :class="customerClass" @click="onToolBarClick" :style="{fontSize: iconSize,color: iconColor}"></i>
    </Tooltip>
  </div>
</template>

<script>
export default {
  name: 'toolbar-button',
  props: {
    toolBarClass: { type: String, defaultL: '' },
    buttonTip: { type: String, default: '' },
    iconBarClass: { type: String, default: '' },
    iconType: { type: String, default: '' },
    actionName: { type: String, default: 'toolButton' },
    tipDelayTime: { type: Number, default: 700 },
    iconColor: { type: String, default: '' },
    disableDefaultOffset: { type: Boolean, default: false },
    iconSize: {
      type: [Number, String],
      default: ''
    },
    customer: { type: Boolean, default: false },
    border: { type: Boolean, default: false }
  },
  computed: {
    customerClass () {
      return [
        { 'tool-bar-button': !this.disableDefaultOffset },
        { [this.iconBarClass]: !!this.iconBarClass }
      ]
    },
    barWrapperClass () {
      return [
        { 'border-wrapper-style': this.border },
        { [this.toolBarClass]: !!this.toolBarClass }
      ]
    }
  },
  methods: {
    onToolBarClick () {
      this.$emit('on-toolbar-click', this.actionName)
    }
  }
}
</script>

<style scoped>
  .global-tool-bar {
    display: inline-block;
    cursor: pointer;
    padding-left: 2px;
  }
  .border-wrapper-style {
    border: 1px solid #b2b2b2;
    line-height: 18px;
    padding: 2px 2px;
    margin-left: 2px;
    border-radius: 4px;
    background-color: white;
  }
  .tool-bar-button {
    margin: 0px 3px;
    font-size: 18px;
    display: inline-block;
  }
</style>
